import {Component} from '@angular/core';
import {MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {BehaviorSubject} from 'rxjs';

@Component({
    selector: 'ngc-totp-mfa-setup-dialog',
    templateUrl: './totp-mfa-setup-dialog.component.html',
    styleUrls: ['./totp-mfa-setup-dialog.component.scss']
})
export class TotpMfaSetupDialogComponent {

    loading$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    recoveryCodes: string[];

    constructor(private dialogRef: MatDialogRef<TotpMfaSetupDialogComponent>) {
    }

    onClose() {
        this.dialogRef.close();
    }

    onSuccess(recoveryCodes?: string[]) {
        if (recoveryCodes?.length > 0) {
            this.recoveryCodes = recoveryCodes;
        } else {
            this.dialogRef.close(true);
        }
    }
}
